import * as React from 'react';
import { useEffect, useState, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { Toast, ToastBody, ToastHeader, Table, Row, Col, Input, Label, Nav, NavItem, NavLink, TabContent, TabPane, Button } from 'reactstrap';
import {
    Afr, getSelectedAfr, Audit, getRow, getFact,
    getSelectedAffiliateReport, isCRAAuditRequired,
    FactTable, AffiliateReporting, isCRA, getTable, loadAfr
} from '../../redux/AfrSlice';

import "react-widgets/styles.css";
import 'react-dropdown-tree-select/dist/styles.css'
import { setIsDirty, isDirty } from '../../redux/MiscSlice';
import enums from '../../utils/enums';
import { Alert } from 'reactstrap';

import AffiliatedEntitiesAuditDetail from './AffiliatedEntitiesAuditDetail';
import AffiliatedEntitySupplementalDetail from './AffiliatedEntitySupplementalDetail';
import Swal from 'sweetalert2';
import { selectUserRole } from '../../redux/UserSlice';
import { EditEntityQuery, loadEntity, resetEntityState } from '../../redux/EntitySlice';
import { Link, useHistory, useLocation } from 'react-router-dom';
import utilityHelper from '../../utils/utilityHelper';
import { getSelectedAffiliateEntityCode } from '../../redux/AffiliateSlice';



const AffiliatedEntityDetail = () => {
    //TODO create a generic reporter component to actually render the topic and details.
    //props should include title and detail list
    const dispatch = useAppDispatch();

    const userRoleSelector = useAppSelector(selectUserRole);
    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const tableId: FactTable | null = getTable(currentAfr, enums.tableName.affiliatedEntity);
    const affiliateCode = useAppSelector(getSelectedAffiliateEntityCode);
    const currentAffiliatedEntity: AffiliateReporting | null | undefined = getSelectedAffiliateReport(currentAfr, affiliateCode);
    const isDirtyInfo = useAppSelector(isDirty);
    /* Tabs logic */
    const [activeTab, setActiveTab] = useState("1");
    
    const toggle = (tab: string) => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const activeClass = (tab: string) => {
        return (tab === activeTab) ? "active" : "";
    }


    const showAuditInformation = function () {

        return isCRA(currentAffiliatedEntity);
    }

    const showSupplementalInformation = function (bIncludeOE: boolean) {
        if ((currentAfr && currentAfr.year < 2021)
            || (affiliateCode && ((Number(affiliateCode) < 300000) || (Number(affiliateCode) > (bIncludeOE ? 699999 : 399999))))) {
            return false;
        }
        var showSupplemental: string = "|" + enums.affiliatedEntityReportingType.blended +
                                       "|" + enums.affiliatedEntityReportingType.zero +
                                       "|" + enums.affiliatedEntityReportingType.discrete + "|";
        var index = -1;

        if (currentAffiliatedEntity) {
            return showSupplemental.includes("|"+currentAffiliatedEntity.reportingType+"|");
        }

        return false;

    }

    const showOESupplementalInformation = function () {
        if ((currentAfr && currentAfr.year < 2021)
            || (affiliateCode && (Number(affiliateCode) < 500000))) {
            return false;
        }
        var showSupplemental: string = "|" + enums.affiliatedEntityReportingType.blended +
            "|" + enums.affiliatedEntityReportingType.zero +
            "|" + enums.affiliatedEntityReportingType.discrete + "|";
        var index = -1;

        if (currentAffiliatedEntity) {
            return showSupplemental.includes("|" + currentAffiliatedEntity.reportingType + "|");
        }

        return false;

    }

    const showAffiliateAfrLink = function () {
        if (!currentAfr || !currentAffiliatedEntity) {
            return false;
        }
        var showSupplemental: string = "|" + enums.affiliatedEntityReportingType.blended +
            "|" + enums.affiliatedEntityReportingType.zero +
            "|" + enums.affiliatedEntityReportingType.discrete + "|";
        var index = -1;

        return !showSupplemental.includes("|" + currentAffiliatedEntity.reportingType + "|");
    }

    const history = useHistory();
    function AffiliatedEntityNameLink(props: any) {
        var result: JSX.Element[] = [];
        if (!currentAffiliatedEntity) {
            return <React.Fragment> {result} </React.Fragment>;
        }
        if (!currentAffiliatedEntity.affiliateReference) {
            return <React.Fragment> {result} </React.Fragment>;
        }
        if (!currentAfr) {
            return <React.Fragment> {result} </React.Fragment>;
        }
        var eCode = currentAffiliatedEntity.affiliateReference.code;
        var showAfrLink: string = "|" + enums.affiliatedEntityReportingType.nonComponentUnit + "|" + enums.affiliatedEntityReportingType.independent + "|";
        if (showAfrLink.includes(currentAffiliatedEntity.reportingType)) {
            result.push(<a
                key={eCode}
                href="javascript:;"

                onClick={() => {

                    if (isDirtyInfo) {
                        Swal.fire({
                            title: '<b>Are you sure?</b>',
                            html: "You are about to navigate to an affiliate AFR, which will"
                                + " discard your changes.  Continue?",
                            icon: 'warning',
                            allowOutsideClick: false,
                            showCancelButton: true,
                            showDenyButton: false,
                            confirmButtonColor: '#3085d6',
                            denyButtonColor: '#28a745',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Yes, continue!',
                            cancelButtonText: 'No, cancel!',
                            reverseButtons: true
                        }).then((result : any) => {

                            if (result.isConfirmed) {

                                var year = currentAfr.year;
                                var entityIdByYear = `${eCode}^${year.toString()}`;


                                dispatch(setIsDirty({ IsDirty: false, Page: "" }))
                                dispatch(loadAfr(entityIdByYear));
                                var eQuery: EditEntityQuery = {
                                    entityId:eCode,
                                    taxonomyYear: year
                                };
                                dispatch(loadEntity(eQuery));

                                if (userRoleSelector == "ADMIN") {
                                    history.push("/EntityAFRManagementA")
                                }
                                else if (userRoleSelector == "ENTITY_USER") {
                                    history.push("/EntityAFRManagement")
                                }

                                return true;
                            } else {

                                return false;
                            }
                        });
                    }
                    else {
                        var year = currentAfr.year;
                        var entityIdByYear = `${eCode}^${year.toString()}`;


                        dispatch(setIsDirty({ IsDirty: false, Page: "" }))
                        dispatch(loadAfr(entityIdByYear));
                        var eQuery: EditEntityQuery = {
                            entityId: eCode,
                            taxonomyYear: year
                        };
                        dispatch(loadEntity(eQuery));

                        if (userRoleSelector == "ADMIN") {
                            history.push("/EntityAFRManagementA")
                        }
                        else if (userRoleSelector == "ENTITY_USER") {
                            history.push("/EntityAFRManagement")
                        }
                    }


                }
            } >Go to AFR for <strong>{currentAffiliatedEntity.affiliateReference.name}</strong></a>);
        }
        else {
            result.push(<Label key={eCode} ><span style={{color:'red'}}>Set reporting type for </span>{currentAffiliatedEntity.affiliateReference.name}</Label>);
        }


        return <React.Fragment> {result} </React.Fragment>;
    }

    var style = "auditDetail";
    var oetitle = (currentAffiliatedEntity && currentAffiliatedEntity.affiliateReference) ? (currentAffiliatedEntity.affiliateReference.name  + " (" + affiliateCode + ")") : "No affiliate selected";

    function getAffiliateDetailOptions(): string {
        if (!tableId || !tableId.rows || tableId.rows.length === 0) {
            return "NOAFFILIATES";
        }
        if (showAffiliateAfrLink()) {
            return "LINK"
        }
        var optionList: string[] = [];
        if (showAuditInformation()) {
            optionList.push("AUDIT");
        }
        if (showSupplementalInformation(false)) {
            optionList.push("SUPPLEMENTAL");
        }
        if (showOESupplementalInformation()) {
            optionList.push("OE");
        }
        return optionList.join("_");
    }

    React.useEffect(() => {

        // Saving pending changes to AfrSlice
        utilityHelper.saveDeferredChanges(dispatch);
    }, [activeTab]);

    const getDetailUIforAffiliate = (stringKeyValue: string) => {
        var result: any = (<></>);
        if (stringKeyValue.length > 0) {
            switch (stringKeyValue) {
                case 'NOAFFILIATES':
                    result =
                        (<>
                            <Row>
                                <Col>
                                    <Alert color="danger">
                                        <p>There are no Affiliated Entities</p>
                                    </Alert>
                                </Col>
                            </Row>
                        </>);
                    break;

                case 'LINK':
                    result =
                        (<Row>
                            <Col>
                                <AffiliatedEntityNameLink />
                            </Col>
                        </Row>);
                    break;

                case 'OE':
                    result =
                        (<Row>
                            <Col>
                                <Toast className={style}>
                                    <ToastHeader className={style}>{oetitle}</ToastHeader>
                                    <ToastBody className={style}>
                                        <h5>Other Entities are not required to report supplemental information.</h5>
                                    </ToastBody>
                                </Toast>
                            </Col>
                        </Row>);
                    break;

                case 'AUDIT':
                    result =
                        (<Row>
                            <Col>
                                <AffiliatedEntitiesAuditDetail />
                            </Col>
                        </Row>);
                    break;

                case 'SUPPLEMENTAL':
                    result =
                        (<Row>
                            <Col>
                                <AffiliatedEntitySupplementalDetail />
                            </Col>
                        </Row>);
                    break;

                case 'AUDIT_SUPPLEMENTAL':
                    result =
                        (<Row>
                            <Col>
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink className={activeClass('1')} onClick={() => { toggle('1'); }} >Audit</NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink className={activeClass('2')} onClick={() => { toggle('2'); }} >Supplemental</NavLink>
                                    </NavItem>
                                </Nav>
                                < TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <Row>
                                            <Col>
                                                <AffiliatedEntitiesAuditDetail />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Row>
                                            <Col>
                                                <AffiliatedEntitySupplementalDetail />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                </TabContent>
                            </Col>
                        </Row>);
                    break;


                default:
                    break;
            }
        }
        return result;
    }



    return (
        <div>
            {getDetailUIforAffiliate(getAffiliateDetailOptions())}       
        </div>
    )

}

export default AffiliatedEntityDetail;